<div id="ht">
    <div id="main-cnt">

        <ion-content class="main-content">
            <div class="scroller-container">
                <div class="content-scroller">
                    <div class="content">

                        <div>
                            <ion-label position="floating">Oggetto</ion-label>
                            <ion-input class="text-input" [(ngModel)]="oggett" type="text"></ion-input>
                            <ion-label position="floating">Messaggio</ion-label>
                            <ion-textarea class="text-input" [(ngModel)]="message" type="text"></ion-textarea>
                            <button  expand="block" (click)="sendRequest()" *ngIf="!loading" class="button-blue">
                                Invia
                            </button>
                            <div *ngIf="loading" class=" center-content ">
                                <ion-spinner></ion-spinner>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </ion-content>
    </div>
</div>